import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';
import {
  NotificationService,
  NOTIFICATION_DURATIONS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
} from 'ui-components/services/notification-service';

import { useModal } from '../../hooks/use-modal';
import { useFetchShipFroms } from '../../pages/settings/ship-from-locations/use-fetch-ship-froms';
import { messages } from '../../pages/settings/stores/selected-store/messages';
import { ShipFromModal } from '../../ship-from/modals';
import { trackShipFromConfigStart } from '../../ship-from/tracking-events';
import { EventSourceStrings } from '../../tracking/tracking-constants';

export const MissingShipFrom = ({ onAddShipFromSuccess = noop, triggerSource = '' }) => {
  const { open, close, isOpen } = useModal();
  const { fetchShipFroms } = useFetchShipFroms();

  const onSuccess = useCallback(
    async ({ shipFromId }) => {
      try {
        close();
        await fetchShipFroms();
        onAddShipFromSuccess(shipFromId);

        NotificationService.showNotification({
          notificationType: NOTIFICATION_TYPE_SUCCESS,
          title: <FormattedMessage {...messages.addShipFromSuccessMessageTitle} />,
          content: '',
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      } catch {
        NotificationService.showNotification({
          notificationType: NOTIFICATION_TYPE_ERROR,
          title: <FormattedMessage {...messages.addShipFromErrorMessageTitle} />,
          content: '',
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      }
    },
    [fetchShipFroms, close, onAddShipFromSuccess],
  );

  const onClick = useCallback(() => {
    open();
    trackShipFromConfigStart(`${triggerSource}-${EventSourceStrings.MISSING_SHIP_FROM}`);
  }, [open, triggerSource]);

  return (
    <>
      <BannerMessageV2
        content={
          <FormattedMessage
            defaultMessage='<a>To start shipping, add a Ship From Location</a>'
            description='shipmentConfigurationWidget.missingShipFromError'
            id='wPOdsF'
            values={{
              a: (chunks) => (
                <Button onClick={onClick} theme='link'>
                  {chunks}
                </Button>
              ),
            }}
          />
        }
        status={BannerStatus.Info}
      />
      {isOpen ? (
        <ShipFromModal onClose={close} onSuccess={onSuccess} source={`${triggerSource}-${EventSourceStrings.MISSING_SHIP_FROM}`} />
      ) : null}
    </>
  );
};

MissingShipFrom.propTypes = {
  onAddShipFromSuccess: PropTypes.func,
  triggerSource: PropTypes.string,
};
